import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import VueI18n from 'vue-i18n';
import messages from './lang';
import Routes from "./routes";
import 'jquery'
import '@fortawesome/fontawesome-free'



const cssThemes_Default = () => import('@/css/index.css')
const cssThemes_Addons = () => import('@/css/onboardingaddons.css')
const cssThemes_DevTheme = () => import('@/css/dev.css')


window.$ = window.jQuery = require('jquery');

switch (window.$("#quickandlight").attr("data-source")) {
  // Used in Dev-Stuff...
  case 'localhost-dev': {
    cssThemes_Default();
    cssThemes_Addons();
    cssThemes_DevTheme();
    break
  }
  default: {
    cssThemes_Default();
    cssThemes_Addons();
   break
  }
  
}

Vue.use(VueI18n);
Vue.use(VueRouter);

const router = new VueRouter({
  // mode:'history',
  routes: Routes
});

export const i18n = new VueI18n({
  locale: 'de',
  fallbackLocale: 'de',
  messages
});

Vue.filter('formatNumber', function (value) {
  if (typeof value !== "number") {
      return value;
  }
  var formatter = new Intl.NumberFormat('de-DE', {
      style: 'decimal',
      minimumFractionDigits: 1
  });
  return formatter.format(value);
});

var filter = function(text, length, clamp){
  clamp = clamp || '...';
  var node = document.createElement('div');
  node.innerHTML = text;
  var content = node.textContent;
  return content.length > length ? content.slice(0, length) + clamp : content;
};

Vue.filter('truncate', filter);

new Vue({
  // el: '#App',
  i18n,
  render: h => h(App),
  router:router
}).$mount('#App');

// new Vue({
//   el: '#navbar',
  
// 	render: h =>
//     h(Navbar, {
      
//     }),
// });



